module.exports = __webpack_public_path__ + "static/media/bgame-logo.e16411fb.svg";